import { Center } from '@mantine/core';

import { SVGIconProps } from '../types';

export const CursorIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3091_23688)">
          <path
            d="M2.5 10H5"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 2.5V5"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.50033 6.50033L4.66699 4.66699"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.5 6.50033L15.3333 4.66699"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.50033 13.5L4.66699 15.3333"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 10L17.5 12.5L14.1667 14.1667L12.5 17.5L10 10Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_3091_23688">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
